import { render, staticRenderFns } from "./DraftInvoiceButton.vue?vue&type=template&id=00c6e818&"
import script from "./DraftInvoiceButton.vue?vue&type=script&lang=ts&"
export * from "./DraftInvoiceButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports